import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import type { DealFindInterface } from '@zaoblako/shared/modules/business/dto/deal/deal-find.dto';
import { SubsKindEnum } from '@zaoblako/shared/modules/project/enum/subs.kind.enum';
import { CrmTableColumn } from '@zaoblako/web/core/models/crm-table-column.interface';
import { ButtonShowAndHideComponent } from '@zaoblako/web/shared/components/button-show-and-hide/button-show-and-hide.component';
import { CardWidgetTypeEnum } from '@zaoblako/web/shared/components/card-helpdesk-widget/enums/card.widget.type.enum';
import { StatusLabelComponent } from '@zaoblako/web/shared/components/status-label/status-label.component';
import { ConditionalRouterLinkDirective } from '@zaoblako/web/shared/directives/conditional-router-link.directive';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { TableComponent } from '@zaoblako/web/shared/dumbs/table/table.component';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'crm-card-deal-widget',
  standalone: true,
  imports: [
    CommonModule,
    ButtonShowAndHideComponent,
    CardModule,
    SpinnerComponent,
    TableComponent,
    StatusLabelComponent,
    ButtonModule,
    SelectButtonModule,
    FormsModule,
    TooltipModule,
    ConditionalRouterLinkDirective
  ],
  templateUrl: './card-deal-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardDealWidgetComponent {
  @Input() public source: CardWidgetTypeEnum;
  @Input() public loading: boolean;
  @Input() public deals: DealFindInterface[] | DealFindInterface;
  @Input() public dealsShow: boolean;
  @Input() public statusKind: SubsKindEnum;
  @Input() public isShowCount: boolean = false;
  @Input() public count: number;
  @Input() public isDisplayCreate: boolean = true;
  @Input() public paginationLoading: boolean;

  @Output() public showButtonChange = new EventEmitter<boolean>();
  @Output() public createDeal = new EventEmitter<void>();
  @Output() public editDeal = new EventEmitter<void>();
  @Output() public scrollEnd = new EventEmitter<HTMLElement>();
  @Output() public changeDealFilter = new EventEmitter<SubsKindEnum>();
  @Output() public navigateToDealList = new EventEmitter<void>();

  public columns: CrmTableColumn[] = [{ label: 'Название' }, { label: 'Контрагент' }, { label: 'Статус' }];

  public dealListKindOptions: { icon: string; label: string; value: SubsKindEnum }[] = [
    { icon: 'pi pi-tags', label: 'Все', value: SubsKindEnum.ALL },
    { icon: 'pi pi-tag', label: 'Активные', value: SubsKindEnum.ACTIVE },
    { icon: 'fa-solid fa-flag-checkered', label: 'Завершенные', value: SubsKindEnum.DONE }
  ];

  public get isCardWidgetTypeClient() {
    return this.source === CardWidgetTypeEnum.CLIENT;
  }

  public get isDealExist() {
    return Array.isArray(this.deals) ? (this.deals as DealFindInterface[])?.length : (this.deals as DealFindInterface);
  }

  public get CardWidgetTypeEnum() {
    return CardWidgetTypeEnum;
  }

  public get getDealValues() {
    return Array.isArray(this.deals) ? (this.deals as DealFindInterface[]) : [this.deals as DealFindInterface];
  }

  public get isCardWidgetTypeHelpdesk() {
    return this.source === CardWidgetTypeEnum.HELPDESK;
  }

  public constructor(private readonly router: Router) {}

  public toDeal(deal: any): DealFindInterface {
    return deal as DealFindInterface;
  }

  public directToDealList() {
    const queryParams = {
      listStyle: 'flat',
      isStartSearch: true
    };
    const url = String(this.router.createUrlTree(['/deal/list'], { queryParams }));
    window.open(url, '_blank');
  }

  public getLabel() {
    return `в список ${this.isShowCount ? '(' + (this.count || 0) + ')' : ''}`;
  }
}
